import { Response } from 'app/api/Response';
import UserApi from 'app/api/UserApi';
import { FormikEvent } from "../core/components/FormikEvent";
import { Form, Formik } from 'formik';
import { isMeDetailsFallback, useMeDetailsQuery } from 'legoland-sdk/dist/experimental';
import { useEffect, useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Button, VGrid, useToasts } from 'tombac';
import { ProductNotificationSettings } from "./ProductNotificationSettings";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserNotificationsForm = _ref => {
  let {
    onChange,
    notifications
  } = _ref;
  const {
    addToast
  } = useToasts();
  const queryClient = useQueryClient();
  const meDetails = useMeDetailsQuery().data?.meDetails;
  const [initialValues, setInitialValues] = useState(null);
  const productIds = useMemo(() => !meDetails || isMeDetailsFallback(meDetails) ? [] : Object.keys(meDetails.emailNotifications).sort().filter(
  // Filter out products that are not in the user's products list
  id => id === 'll' ||
  // Always include Move
  meDetails.products.some(userProduct => userProduct.id === id)), [meDetails]);
  useEffect(() => {
    const updatedNotifications = notifications ?? (meDetails && !isMeDetailsFallback(meDetails) ? meDetails?.emailNotifications : null);
    if (updatedNotifications === null) {
      setInitialValues(null);
    } else {
      setInitialValues(convertSettingsToFormValues(updatedNotifications, productIds));
    }
  }, [meDetails, notifications, productIds]);
  if (initialValues === null) {
    return null;
  }
  const handleSubmit = async values => {
    const response = await UserApi.updateEmailNotifications(values);
    queryClient.invalidateQueries(['legoland', 'users', 'me-details']);
    return Response.match(response, () => {
      addToast('Your settings are successfully updated.', 'success');
      setInitialValues(values);
    }, error => {
      console.error(error);
      addToast(error?.message ?? (typeof error === 'string' ? error : 'Error while updating your settings. Please try again.'), 'danger');
    });
  };
  const handleValuesChange = values => {
    if (!onChange) return;
    if (JSON.stringify(values) !== JSON.stringify(notifications)) {
      onChange(values);
    }
  };
  return /*#__PURE__*/_jsx(Formik, {
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: handleSubmit,
    "data-sentry-element": "Formik",
    "data-sentry-component": "UserNotificationsForm",
    "data-sentry-source-file": "UserNotificationsForm.tsx",
    children: _ref2 => {
      let {
        dirty,
        isSubmitting
      } = _ref2;
      return /*#__PURE__*/_jsxs(Form, {
        children: [/*#__PURE__*/_jsx(FormikEvent, {
          onValuesChange: handleValuesChange
        }), /*#__PURE__*/_jsx(VGrid, {
          justifyContent: "stretch",
          children: productIds.map(productId => /*#__PURE__*/_jsx(ProductNotificationSettings, {
            productId: productId
          }, `product-${productId}`))
        }), !onChange && /*#__PURE__*/_jsx(Button, {
          busy: isSubmitting,
          disabled: !dirty,
          $mt: "3sp",
          type: "submit",
          variant: "primary",
          children: "Save settings"
        })]
      });
    }
  });
};
function convertSettingsToFormValues(notifications, productIds) {
  const formValues = {
    ...notifications
  };
  for (const productId of productIds) {
    if (!formValues[productId]) {
      formValues[productId] = {
        application: false,
        releaseNotes: false
      };
    }
  }
  return formValues;
}
export default UserNotificationsForm;